import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const Login = async (credentials) => {
  try {
    const response = await APIs.post(`/login_admins`, credentials);

    if (response?.data?.message?.toLowerCase() === 'success') {
      toast('Login Successfully');

      await localStorage.removeItem('token');

      APIs.defaults.headers[
        'Authorization'
      ] = `Bearer ${response?.data?.token}`;

      localStorage.setItem('admin_token', response?.data?.token);

      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleUser = async (payload) => {
  try {
    const response = await APIs.get(`/get_admin_user`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const AuthServices = {
  Login,
  getSingleUser,
};

export default AuthServices;
